// @flow
import { OptionAnswersActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    optionAnswer: {},
    listaOptionAnswers: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false
};

type OptionAnswersAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { optionAnswer?: {} | null, listaOptionAnswers?: [] | null, loading?: boolean, +value ?: boolean };

const OptionAnswers = (state: State = INIT_STATE, action: OptionAnswersAction): any => {
    // console.log(action);
    switch (action.type) {
        case OptionAnswersActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case OptionAnswersActionTypes.GET_OPTION_ANSWER: {
                    return {
                        ...state,
                        optionAnswer: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case OptionAnswersActionTypes.LIST_OPTION_ANSWERS: {
                    return {
                        ...state,
                        listaOptionAnswers: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case OptionAnswersActionTypes.ADD_OPTION_ANSWER: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case OptionAnswersActionTypes.UPDATE_OPTION_ANSWER: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case OptionAnswersActionTypes.DELETE_OPTION_ANSWER: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case OptionAnswersActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case OptionAnswersActionTypes.GET_OPTION_ANSWER: {
                    return {
                        ...state,
                        error: action.payload.error,
                        optionAnswer: {},
                        loading: false,
                    };
                }
                case OptionAnswersActionTypes.LIST_OPTION_ANSWERS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaOptionAnswers: [],
                        loading: false,
                    };
                }
                case OptionAnswersActionTypes.ADD_OPTION_ANSWER: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case OptionAnswersActionTypes.UPDATE_OPTION_ANSWER: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case OptionAnswersActionTypes.DELETE_OPTION_ANSWER: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case OptionAnswersActionTypes.GET_OPTION_ANSWER:
            return { ...state, error: false, loading: true };
        case OptionAnswersActionTypes.LIST_OPTION_ANSWERS:
            return { ...state, error: false, loading: true };
        case OptionAnswersActionTypes.ADD_OPTION_ANSWER:
            return { ...state, error: false, loadingForm: true };
        case OptionAnswersActionTypes.UPDATE_OPTION_ANSWER:
            return { ...state, error: false, loadingForm: true };
        case OptionAnswersActionTypes.DELETE_OPTION_ANSWER:
            return { ...state, error: false, loading: true };
        case OptionAnswersActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                optionAnswer: {},
                listaOptionAnswers: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default OptionAnswers;
